import React, { useState } from "react";
import { Modal, Box, Typography, Button, CircularProgress } from "@mui/material";
import { deletePartner } from "./api"; // Import the delete API function
import { toast } from "react-toastify"; // Import toast

const DeleteConfirmationModal = ({ open, handleClose, user, onDeleteSuccess }) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!user?.userid) return;

    setLoading(true); // Start loading

    try {
      const response = await deletePartner(user.userid);
      const message = response?.body?.message || "Something went wrong."; // Extract message

      switch (response?.statusCodeValue) {
        case 200:
          toast.success(message, { position: "top-right", autoClose: 3000, theme: "colored" });
          if (onDeleteSuccess) onDeleteSuccess(); // Fetch data after successful delete
          handleClose();
          break;

        case 406:
          toast.warn(message, { position: "top-right", autoClose: 5000, theme: "colored" });
          break;

        case 500:
          toast.error(message, { position: "top-right", autoClose: 5000, theme: "colored" });
          break;

        default:
          toast.error(message, { position: "top-right", autoClose: 5000, theme: "colored" });
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      toast.error("An unexpected error occurred.", { position: "top-right", autoClose: 5000, theme: "colored" });
    } finally {
      setLoading(false); // Stop loading
    }
  };


  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: 350, sm: 400, md: 450 },
          bgcolor: "rgba(255, 255, 255, 0.95)",
          backdropFilter: "blur(12px)",
          p: { xs: 3, sm: 4 },
          borderRadius: 3,
          boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15)",
          textAlign: "center",
        }}
      >
        <Typography variant="h5" fontWeight="bold" color="error">
          Confirm Deletion
        </Typography>
        <Typography sx={{ mt: 2, fontSize: "1rem", color: "#444", lineHeight: 1.6 }}>
          Are you sure you want to delete <b>{user?.mobileNumber}</b> <br />
          with User ID: <b>{user?.userid}</b>?
          <br />
          <span style={{ color: "#d32f2f", fontWeight: 500 }}>
            This action is irreversible.
          </span>
        </Typography>

        <Box sx={{ mt: 4, display: "flex", justifyContent: "center", gap: 2 }}>
          <Button
            variant="outlined"
            onClick={handleClose}
            disabled={loading}
            sx={{
              px: 4,
              py: 1.5,
              borderRadius: "8px",
              fontWeight: "bold",
              fontSize: "0.95rem",
              color: "#333",
              borderColor: "#aaa",
              transition: "all 0.3s",
              "&:hover": {
                borderColor: "#666",
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={handleDelete}
            disabled={loading}
            sx={{
              px: 4,
              py: 1.5,
              borderRadius: "8px",
              fontWeight: "bold",
              fontSize: "0.95rem",
              bgcolor: "#d32f2f",
              transition: "all 0.3s",
              "&:hover": { bgcolor: "#b71c1c" },
            }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "Delete"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteConfirmationModal;
